import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Film } from 'lucide-react';

// Video testimonials — real guest videos to be added later.
// Set `video` to a direct mp4 URL when available; until then the card shows a blank placeholder.
const TESTIMONIALS = [
  {
    name: 'Vasanth',
    location: 'Bengaluru',
    quote: 'We came for a weekend. We left with stories that will last a lifetime.',
    video: null,
  },
  {
    name: 'Sitara',
    location: 'Mumbai',
    quote: 'A tusker walked past our balcony at dawn. Nothing prepared us for that.',
    video: null,
  },
  {
    name: 'Girish',
    location: 'Kochi',
    quote: 'Easily one of the finest stays in Wayanad — it feels like home.',
    video: null,
  },
];

const TestimonialsSection = () => {
  return (
    <section id="testimonials" className="relative bg-[#121816] py-32 md:py-44 overflow-hidden" data-testid="testimonials-section">

      <div className="max-w-[1480px] mx-auto px-6 md:px-12">

        {/* chapter heading */}
        <div className="grid grid-cols-12 gap-6 mb-14 md:mb-20">
          <div className="col-span-12 lg:col-span-3">
            <div className="overline">Chapter VIII</div>
            <div className="numeral text-7xl md:text-8xl text-[#D4AF37]/30 mt-4">08</div>
          </div>
          <div className="col-span-12 lg:col-span-9">
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              className="font-serif text-4xl md:text-6xl lg:text-7xl font-light text-[#E8E3D9] leading-[1.05]"
            >
              In their own<br/>
              <span className="italic text-[#D4AF37]">words.</span>
            </motion.h2>
            <p className="mt-6 max-w-xl text-[#8E9A95] text-[15px] leading-relaxed">
              The voices of guests who came strangers and left as family.
            </p>
          </div>
        </div>

        {/* testimonial grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.8, delay: i * 0.12 }}
              className="group"
              data-testid={`testimonial-${i}`}
            >
              {/* video card */}
              <div className="relative aspect-[4/5] overflow-hidden bg-[#1A2421] border border-[#D4AF37]/20 hover:border-[#D4AF37]/50 transition-colors">
                {t.video ? (
                  <video
                    src={t.video}
                    className="absolute inset-0 w-full h-full object-cover"
                    controls
                    playsInline
                    preload="metadata"
                    data-testid={`testimonial-video-${i}`}
                  />
                ) : (
                  <>
                    {/* blank placeholder until real video provided */}
                    <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-gradient-to-b from-[#1A2421] to-[#0B0F0E]">
                      <div className="w-14 h-14 rounded-full border border-[#D4AF37]/40 flex items-center justify-center">
                        <Film size={20} className="text-[#D4AF37]/70" />
                      </div>
                      <div className="overline text-[10px] text-[#8E9A95]">Video coming soon</div>
                    </div>

                    {/* quote overlay */}
                    <div className="absolute bottom-0 inset-x-0 p-6">
                      <Quote size={20} className="text-[#D4AF37]/70 mb-2" />
                      <p className="font-serif italic text-lg md:text-xl text-[#E8E3D9] leading-snug">
                        "{t.quote}"
                      </p>
                    </div>
                  </>
                )}
              </div>

              {/* meta below card */}
              <div className="mt-4 flex items-baseline justify-between">
                <div>
                  <div className="font-serif text-lg text-[#E8E3D9]">{t.name}</div>
                  <div className="overline text-[10px] mt-1">{t.location}</div>
                </div>
                <div className="numeral text-2xl text-[#D4AF37]/30">{String(i + 1).padStart(2, '0')}</div>
              </div>
            </motion.div>
          ))}
        </div>

        <p className="text-center text-[11px] tracking-[0.2em] uppercase text-[#8E9A95] mt-12 italic">
          More guest stories joining soon · share yours with us @tuskermark_safari_retreat
        </p>
      </div>
    </section>
  );
};

export default TestimonialsSection;
